import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { bulkUpdateToList } from './bulkUpdateToList';
import { addRenewalsToSelectionList } from '../subscription-management/renewals/addRenewalsToSelectionList';
import { invalidateManageRenewalsTotals } from '../subscription-management/renewals/useManageRenewalsTotals';
import { invalidateRenewalLines } from '../subscription-management/renewals/useRenewals';
import { invalidateManageSubscriptionData } from '../subscription-management/useMagazinSubscriptionData';

export const useAddRenewalsToList = () => {
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);

    return {
        isLoading,
        addToListBulk: (listId: string, totalValue: number, performChecks: boolean) => {
            const apiCallback = () => addRenewalsToSelectionList(listId, totalValue, performChecks);

            return bulkUpdateToList({
                setLoading,
                apiCallback,
                t,
                onSuccess: () => {
                    invalidateManageRenewalsTotals().then();
                    invalidateRenewalLines().then();
                    invalidateManageSubscriptionData().then();
                }
            });
        }
    };
};
